import { useQuery } from '@tanstack/react-query';
import { fetchPendingSummary } from '../lib/api';

export function usePendingSummary() {
  return useQuery({
    queryKey: ['pending-summary'],
    queryFn: fetchPendingSummary,
    staleTime: 30_000,
  });
}
